import { SearchOutlined } from '@ant-design/icons';
import { Input, Button, Space } from 'antd';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './SearchBar.module.scss';

interface Props {
  onSearch: (searchString: string) => void;
  className?: string;
  placeholder?: string;
}

export function SearchBar(props: Props) {
  const { onSearch, className, placeholder } = props;
  const [query, setQuery] = useState<string>('');

  return (
    <Space className={classNames(styles.container, 'mb-2', className)}>
      <Input
        className={styles.searchInput}
        value={query}
        onChange={(e) => {
          const val = e.target.value;
          setQuery(val);
          if (val === '') {
            onSearch('');
          }
        }}
        allowClear
        placeholder={placeholder}
      />

      <Button
        type="link"
        icon={<SearchOutlined />}
        onClick={() => onSearch(query)}
        className={styles.searchButton}
      />
    </Space>
  );
}
